import { AnimatedCircularProgress, AnimatedNumber } from "@/lib/animations";

interface DaysActiveRingProps {
  daysCompleted: number;
  totalDays: number;
  isWinner?: boolean;
}

export function DaysActiveRing({
  daysCompleted,
  totalDays,
  isWinner = true,
}: DaysActiveRingProps) {
  const percentage =
    totalDays === 0 ? 0 : Math.min(100, (daysCompleted / totalDays) * 100);

  return (
    <div className="col-span-1 rounded-4xl bg-white/5 border border-white/5 p-4 flex flex-col items-center justify-center relative">
      <AnimatedCircularProgress
        value={percentage}
        size={90}
        radius={36}
        strokeWidth={8}
        trackClassName="text-white/10"
        progressClassName="text-primary drop-shadow-[0_0_4px_rgba(37,244,120,0.8)]"
        delay={0.2}
      >
        <div className="flex flex-col items-center">
          <div className="flex items-baseline">
            <AnimatedNumber
              value={daysCompleted}
              className="text-xl font-bold text-white"
            />
            {!isWinner && (
              <span className="text-xs font-bold text-white/50">
                /{totalDays}
              </span>
            )}
          </div>
          <span className="text-[10px] text-white/60 font-medium">days</span>
        </div>
      </AnimatedCircularProgress>
      <p className="text-xs font-medium text-white/70 mt-2">
        <AnimatedNumber value={Math.round(percentage)} />%{" "}
        {isWinner ? "Active" : "Consistency"}
      </p>
    </div>
  );
}
